"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FooterLinks_1 = require("./FooterLinks");
exports.default = FooterLinks_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/cards/index.js
// module id = 1381
// module chunks = 8